var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{attrs:{"loading":_setup.us_announcement.loading,"empty":_setup.isEmpty}},[(_setup.announcementList.length)?_c(_setup.MobDocumentCard,{attrs:{"listData":_setup.announcementList,"showIcon":true},on:{"goDetail":_setup.handlePreview}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }